
import Header from "../Common/Header";
import Footer from "../Common/Footer";
function G2C() {
  return (
   <>
   <Header />
    {/* Start Our Features area */}
    <div className="features-area pt-100 pb-70 bgcolor">
      <div className="container">
        <div className="section-title">
          
          <h2>G2C Services</h2>
        </div>
        <div className="row">
        <div className="col-lg-12 col-sm-12 col-md-12">
          <div class="section-title leftalign">
            
        <span className="">G2C Services
        </span>
          </div>
          </div>
          </div>
          <div className="row parent">
          <div className="col-lg-3 col-sm-6 col-md-6">

          <div class="services-three-card">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/passport.svg"  />
                            </div>
                            <h3>Passport
                            </h3>
                        </div>
                        <p>An official document issued by a governmernt

</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
</div>


          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">
          <div class="services-three-card">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/marriage-certificate.svg"  />
                            </div>
                            <h3>Marriage Certificate


                            </h3>
                        </div>
                        <p>Get registered and apply for Marriage Certificate




                        </p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
</div>

          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">
          <div class="services-three-card">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/driving-license.svg"  />
                            </div>
                            <h3>Driving Licence

                            </h3>
                        </div>
                        <p>Now apply for Driving Licence through NDLS



</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
          </div>
          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">

          <div class="services-three-card">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/cast-certificate.svg"  />
                            </div>
                            <h3>Caste Certificate

                            </h3>
                        </div>
                        <p>Now apply for Caste Certificate online

</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
          </div>

          </div>

          <div className="col-lg-3 col-sm-6 col-md-6">

<div class="services-three-card">
<div className="child">
              <div class="services-card d-flex align-items-center">
                  <div class="services-icon bg-icon-color">
                  <img src="assets/images/proicon/income-certification.svg"  />
                  </div>
                  <h3>Income Certificate

                  </h3>
              </div>
              <p>This certificate establishes the annual income



</p>
              <a href="#" class="default-btn">Apply Now</a>
          </div>

</div>

</div>
<div className="col-lg-3 col-sm-6 col-md-6">
<div class="services-three-card">
<div className="child">
              <div class="services-card d-flex align-items-center">
                  <div class="services-icon bg-icon-color">
                  <img src="assets/images/proicon/domicile-certificate.svg"  />
                  </div>
                  <h3>Domicile Certificate



                  </h3>
              </div>
              <p>Domicile certificate or residence certificate


              </p>
              <a href="#" class="default-btn">Apply Now</a>
          </div>
</div>

</div>
<div className="col-lg-3 col-sm-6 col-md-6">
<div class="services-three-card">
<div className="child">
              <div class="services-card d-flex align-items-center">
                  <div class="services-icon bg-icon-color">
                  <img src="assets/images/proicon/birth-certificate.svg"  />
                  </div>
                  <h3>Birth Certificate
                  </h3>
              </div>
              <p>Birth Certificate. Documents Required for Certificate

</p>
              <a href="#" class="default-btn">Apply Now</a>
          </div>

</div>
</div>

        </div>


      </div>
    </div>
    {/* End Our Features area */}
  
    <Footer />
   </>
  );
}

export default G2C;
